export const createSummaryFromData = (data, layout) => {
  if (data && layout) {
    const summaryArray = [];
    const selectedLayouts = [];
    Object.entries(layout).forEach(([key, value]) => {
      if (value) {
        selectedLayouts.push(key);
      }
    });

    selectedLayouts.forEach((layout) => {
      const value = data[layout];
      if (value) summaryArray.push(value);
    });

    return summaryArray.join(", ");
  }
  return "";
};
